import { createSlice } from "@reduxjs/toolkit";
import { IHealthPlanRate, IShelfPlanAdminCost, IShelfPlanInformation } from "components/health/shelfPlans/information/Information.interface";
import { IHealthPlanServiceRateConfiguration } from "container/health/planSetup/b2c/shelfPlans/services/shelfPlanService.interface";
import { RootState } from "redux/store";
import { SALE_POINTS } from "shared/constant";
import { IListOfValues } from "shared/interface/types";

interface IHealthInitialState {
  ShelfPlan: IShelfPlanInformation;
  ActivePriceSalePoint: keyof typeof SALE_POINTS;
  ShelfPlanAdminCost: IShelfPlanAdminCost;
  HealthPlanRateConfiguration: IHealthPlanRate[];
  HealthPlanActivePlans: string[];
  HealthPlanService: {
    id: string;
    healthPlanServiceRateConfiguration?: IHealthPlanServiceRateConfiguration[];
    service?: { contribution: IListOfValues; id: number; name: string };
  };
}
const initialState: IHealthInitialState = {
  ShelfPlan: {
    healthPlanGenders: [],
    planTypeId: 0,
    priceTypeId: 0,
    id: "",
    takafulProviderId: 0,
    productName: "",
    salePoint: [],
    renewalMinAge: 0,
    renewalMaxAge: 0
  },
  HealthPlanService: {
    id: ""
  },
  ActivePriceSalePoint: "",
  ShelfPlanAdminCost: {
    adminCostMax: 0,
    adminCostMaxTypeId: 0,
    adminCostMin: 0,
    adminCostMinTypeId: 0
  },
  HealthPlanRateConfiguration: [],
  HealthPlanActivePlans: []
};

const healthSlice = createSlice({
  name: "health",
  initialState,
  reducers: {
    AddHealthShelfPlan: (state, action) => {
      state.ShelfPlan = action.payload;
    },
    AddHealthPlanService: (state, action) => {
      state.HealthPlanService = action.payload;
    },
    DeleteHealthShelfPlan: state => {
      state.ShelfPlan = initialState.ShelfPlan;
    },
    UpdateActiveSalePoint: (state, action) => {
      state.ActivePriceSalePoint = action.payload;
    },
    UpdateAdminCostForShelfPlanPrice: (state, action) => {
      state.ShelfPlanAdminCost = action.payload;
    },
    UpdateHealthPlanRateConfiguration: (state, action) => {
      state.HealthPlanRateConfiguration = action.payload;
    },
    UpdateHealthActivePlan: (state, action) => {
      state.HealthPlanActivePlans = action.payload;
    }
  }
});

export const {
  AddHealthShelfPlan,
  DeleteHealthShelfPlan,
  UpdateActiveSalePoint,
  UpdateAdminCostForShelfPlanPrice,
  UpdateHealthPlanRateConfiguration,
  UpdateHealthActivePlan,
  AddHealthPlanService
} = healthSlice.actions;
export default healthSlice.reducer;

export const getHealthShelfPlan = (state: RootState): IHealthInitialState => state.health;
